import { render } from "./OverlaysList.htm?vue&type=template&id=dc385998&scoped=true&ts=true"
import script from "./OverlaysList.vue?vue&type=script&lang=ts"
export * from "./OverlaysList.vue?vue&type=script&lang=ts"

import "./OverlaysList.scss?vue&type=style&index=0&id=dc385998&lang=scss&scoped=true"

import exportComponent from "C:\\Projets\\FIFA\\Dev\\GIS-Dispatcher-Front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc385998"]])

export default __exports__